<div class="valign-wrapper flex-selecter-calendar">
  <button class="changemonth-btn action-button" (click)="setPreviousDay()">
      <<
    </button>
  <div class="monthlabel">
    <span>{{monthNames[month - 1]}} {{year}}</span>
  </div>
  <button class="changemonth-btn action-button" (click)="setNextDay()">
      >>
    </button>
</div>
<div class="row">
  <table class='calendar'>
    <tr class='weekdays-list'>
      <td class="center"><b><span translate>schedule.daily.calendar.days.sunday</span></b></td>
      <td class="center"><b><span translate>schedule.daily.calendar.days.monday</span></b></td>
      <td class="center"><b><span translate>schedule.daily.calendar.days.tuesday</span></b></td>
      <td class="center"><b><span translate>schedule.daily.calendar.days.wednesday</span></b></td>
      <td class="center"><b><span translate>schedule.daily.calendar.days.thursday</span></b></td>
      <td class="center"><b><span translate>schedule.daily.calendar.days.friday</span></b></td>
      <td class="center"><b><span translate>schedule.daily.calendar.days.saturday</span></b></td>
    </tr>
    <tr class="calendar-boxes" *ngFor="let line of calendarData">
      <td *ngFor="let item of line.cols">
        <div class='day-off' *ngIf="item === 0"></div>
        <div *ngIf="item > 0">
          <div class="day-enable" [ngClass]="setStyle(item)" (click)="selectDay(item)">{{item}}</div>
        </div>
      </td>
    </tr>
  </table>
</div>